<template>
    <div>
      <table class="schedule-table">
        <thead>
          <tr>
            <th>Name</th>
            <th v-for="hour in hours" :key="hour">{{ hour }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="handyman in handymen" :key="handyman.name">
            <td class="name-cell">{{ handyman.name }}</td>
            <td 
              v-for="hour in hours" 
              :key="hour"
              :style="getCellStyle(handyman, hour)"
            >
              {{ getCellContent(handyman, hour) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        hours: ['7AM', '8AM', '9AM', '10AM', '11AM', '12PM', '1PM', '2PM', '3PM', '4PM', '5PM'],
        handymen: [
          {
            "name": "Richard Simons",
            "workingHours": {
              "start": "09:00",
              "end": "17:00"
            },
            "bookings": [
              
              {
                "start": "11:30",
                "end": "13:30",
                "order_id": 947
              }
            ]
          }
        ]
      };
    },
    methods: {
      convertHourTo24(hourStr) {
        const [_, timePart, period] = hourStr.match(/(\d+)(AM|PM)/);
        let hour = parseInt(timePart, 10);
        if (period === 'PM' && hour !== 12) hour += 12;
        if (period === 'AM' && hour === 12) hour = 0;
        return hour;
      },
  
      timeToMinutes(timeStr) {
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours * 60 + minutes;
      },
  
      getSlotTimeRange(hourStr) {
        const hour = this.convertHourTo24(hourStr);
        return {
          start: hour * 60,
          end: (hour + 1) * 60
        };
      },
  
      getCellStyle(handyman, hour) {
        const slot = this.getSlotTimeRange(hour);
        const workStart = this.timeToMinutes(handyman.workingHours.start);
        const workEnd = this.timeToMinutes(handyman.workingHours.end);
        
        // Calculate available time
        const availableStart = Math.max(slot.start, workStart);
        const availableEnd = Math.min(slot.end, workEnd);
        const totalAvailable = Math.max(0, availableEnd - availableStart);
        
        // Calculate booked time
        let bookedMinutes = 0;
        handyman.bookings.forEach(booking => {
          const bookingStart = this.timeToMinutes(booking.start);
          const bookingEnd = this.timeToMinutes(booking.end);
          const overlapStart = Math.max(bookingStart, availableStart);
          const overlapEnd = Math.min(bookingEnd, availableEnd);
          bookedMinutes += Math.max(0, overlapEnd - overlapStart);
        });
  
        const bookedPercentage = totalAvailable > 0 
          ? (bookedMinutes / totalAvailable) * 100 
          : 0;
  
        // Create gradient background
        if (bookedPercentage === 0) {
          return { backgroundColor: '#c8e6c9' }; // Fully available
        } else if (bookedPercentage === 100) {
          return { backgroundColor: '#ffcdd2' }; // Fully booked
        } else {
          return { 
            background: `linear-gradient(to right,
              #ffcdd2 ${bookedPercentage}%,
              #c8e6c9 ${bookedPercentage}%)`
          };
        }
      },
  
      getCellContent(handyman, hour) {
        const slot = this.getSlotTimeRange(hour);
        const booking = handyman.bookings.find(b => {
          const bookingStart = this.timeToMinutes(b.start);
          const bookingEnd = this.timeToMinutes(b.end);
          return bookingStart < slot.end && bookingEnd > slot.start;
        });
        return booking ? `C: ${booking.order_id}` : '';
      }
    }
  };
  </script>
  
  <style>
  .schedule-table {
    border-collapse: collapse;
    width: 100%;
    font-family: Arial, sans-serif;
  }
  
  .schedule-table th, 
  .schedule-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
    min-width: 60px;
  }
  
  .name-cell {
    font-weight: bold;
    background-color: #f5f5f5;
  }
  
  .schedule-table th {
    background-color: #607d8b;
    color: white;
    font-weight: bold;
  }
  </style>